import * as Yup from "yup";
import { z } from "zod";

const dateStringSchema = z
  .string()
  .min(1, "Required")
  .refine((value) => {
    if (!value) return false;
    const date = new Date(value);
    return date instanceof Date && !isNaN(date.getTime());
  }, "Invalid date");

export const UserIdSchema = z.object({
  id: z.string().min(1, "Required ID"),
  email: z.email("Invalid email").min(1, "Required email"),
  isOnboardingCompleted: z.boolean().optional(),
});

export const UserSchema = z.object({
  firstName: z.string().min(1, "Required"),
  lastName: z.string().min(1, "Required"),
  dob: dateStringSchema,
  sex: z.string().min(1, "Required"),
});

export const BodyStatsSchema = z.object({
  height: z.string().min(1, "Required"),
  heightUnit: z.string().optional(),
  currentWeight: z.string().min(1, "Required"),
  currentWeightUnit: z.string().min(1, "Required"),
  targetWeight: z.string().optional(),
  targetWeightUnit: z.string().optional(),
});

export const LifestyleSchema = z.object({
  activityLevel: z.string().min(1, "Required"),
});

export const GoalsSchema = z.object({
  specificWeightGoals: z.string().min(1, "Required"),
  goalsWithNutriCoach: z.string().min(1, "Required"),
});

export const MedicalSchema = Yup.object().shape({
  medicalConditions: Yup.array().of(Yup.string()).required("Required"),
  allergies: Yup.array().of(Yup.string()).required("Required"),
});

export const UserDetailsSchema = UserSchema.pick({
  firstName: true,
  lastName: true,
});
export const UserStatusDetailsSchema = UserSchema.pick({
  sex: true,
  dob: true,
});

export const UserBodyStatsSchema = BodyStatsSchema.pick({
  height: true,
  heightUnit: true,
  currentWeight: true,
  currentWeightUnit: true,
  targetWeight: true,
  targetWeightUnit: true,
});

export const UserStatusSchema = UserStatusDetailsSchema.extend({
  ...UserStatusDetailsSchema.shape,
  ...UserBodyStatsSchema.pick({
    height: true,
    heightUnit: true,
    currentWeight: true,
    currentWeightUnit: true,
  }).shape,
  ...GoalsSchema.pick({
    goalsWithNutriCoach: true,
  }).shape,
});

export const ActivityLevelSchema = LifestyleSchema.pick({
  activityLevel: true,
});

export const ProfilingGoalsSchema = GoalsSchema.pick({
  goalsWithNutriCoach: true,
});

export const FoodPreferencesSchema = Yup.object().shape({
  foodToSkip: Yup.array().of(Yup.string()).required("Required"),
});

export const ProfilingMedicalSchema = MedicalSchema.pick(["medicalConditions"]);

export const ProfilingAllergiesSchema = MedicalSchema.pick(["allergies"]);

export const MyProfileSchema = UserDetailsSchema.extend({
  ...UserBodyStatsSchema.shape,
  ...ActivityLevelSchema.shape,
});
